/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { configuredClustersStore, processApplicationStore } from 'stores';
import { DeployModal, PlayDeployEndpointConfigModal } from 'App/Pages/Diagram/features/deployment';
import { isPlayMode } from 'App/Pages/Diagram/Deployment/executeModal/modeUtils';
import { deploymentStore } from 'App/Pages/Diagram/Deployment/stores/';

export const ExecuteModal = ({ open = false, onClose = () => {}, mode = 'execute' }) => {
  const { processApplicationVersionId } = deploymentStore;

  useEffect(() => {
    const fetchData = async () => {
      if (open && processApplicationStore.fromAProcessApplication) {
        await processApplicationStore.getExternalResources(processApplicationVersionId);
      }
    };

    fetchData();
  }, [open, processApplicationVersionId]);

  if (configuredClustersStore.isClustersConfigured) {
    if (isPlayMode(mode)) {
      return <PlayDeployEndpointConfigModal isOpen={open} onClose={onClose} />;
    } else {
      return <DeployModal isOpen={open} onClose={onClose} mode={mode} />;
    }
  }

  return null;
};

ExecuteModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  mode: PropTypes.oneOf(['deploy', 'execute', 'play'])
};

export default observer(ExecuteModal);
